module.exports = {"id":"232244","name":"Santiago Ascacibar","rating":"76","photo":"./data/images/photos/1/232244.png","club":{"name":"VfB Stuttgart","logo":"./data/images/clubs/VfBStuttgart.png"},"positions":["MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SantiagoAscacibar0.json
// module id = 3825
// module chunks = 0